'use strict';

import formHelper from './form-helper';
import { Form } from './form';

const JS_CLASS = 'js-form-donation';

class FormDonation extends Form {
  addListeners() {
    super.addListeners();

    this.dom.$postOffice = this.dom.$form.find('.' + JS_CLASS + '__post-office');

    // Automatically fill post office
    formHelper.postalCode.on('fetchOffice', (postOffice) => {
      this.dom.$postOffice.val(postOffice);
      this.dom.$postOffice.trigger('change');
    });

    // Get hints for payment method field
    const PAYMENT_METHOD_FIELD = 'recurring_payment_method';
    this.dom.$hints = this.dom.$form.find('.js-form__hint').filter(`[data-field="${PAYMENT_METHOD_FIELD}"]`);

    // Show active hint
    const paymentMethodValue = this.getFieldValue(PAYMENT_METHOD_FIELD);
    this.dom.$hints.filter(`[data-value="${paymentMethodValue}"]`).attr('aria-hidden', 'false');

    // Listen on form value changes
    this.on('change', (fieldName, value) => {
      if (fieldName === PAYMENT_METHOD_FIELD) {
        // Hide all
        this.dom.$hints.attr('aria-hidden', 'true');

        // Show active hint
        this.dom.$hints.filter(`[data-value="${value}"]`).attr('aria-hidden', 'false');
      }
    });
  }
}

export { FormDonation }
